import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { hasAnalyticsConsent } from "@/lib/cookieConsent";

function getSessionId(): string {
  let sid = sessionStorage.getItem("uc_session_id");
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem("uc_session_id", sid);
  }
  return sid;
}

export function useVisitorTracking() {
  const location = useLocation();
  const lastPath = useRef("");

  useEffect(() => {
    // Only track if user consented to analytics cookies
    if (!hasAnalyticsConsent()) return;

    const path = location.pathname;
    // Don't double-track same path
    if (path === lastPath.current) return;
    // Don't track admin pages
    if (path.startsWith("/admin")) return;

    lastPath.current = path;

    const sessionId = getSessionId();

    supabase
      .from("page_views" as any)
      .insert({
        session_id: sessionId,
        page_path: path,
        referrer: document.referrer || null,
        user_agent: navigator.userAgent?.slice(0, 500) || null,
      })
      .then(({ error }) => {
        if (error) console.error("Page view tracking error:", error);
      });
  }, [location.pathname]);
}
